import { render, staticRenderFns } from "./ref-date.vue?vue&type=template&id=0ff84734&"
import script from "./ref-date.vue?vue&type=script&lang=js&"
export * from "./ref-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports